import { validate } from '../../shared/validation';
import { ValidationResponse } from '../../shared/validation/types';
import { CompleteGettingStartedTaskPayload } from '../db/types';

import { COMPLETE_GETTING_STARTED_TASK_SCHEMA } from './schemas';

export function validateCompleteGettingStartedTaskPayload(
  payload: CompleteGettingStartedTaskPayload
): Promise<ValidationResponse<CompleteGettingStartedTaskPayload>> {
  return validate<CompleteGettingStartedTaskPayload>(COMPLETE_GETTING_STARTED_TASK_SCHEMA, payload);
}
